import { isNotNil, Nillable } from '@web/utils';

export const getAlt = (title: string, alternativeText?: Nillable<string>) => {
  if (isNotNil(alternativeText)) {
    return alternativeText;
  }

  return title;
};
